import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export default function SectionHeading(props) {
    const { title, onClick, shouldShowArrow = true } = props;
    const useStyles = makeStyles((theme) => ({
        title: {
            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Medium',
            fontSize: 18,
            fontWeight: 'normal',
            color: themes.palette.primary.main,
            cursor: 'pointer',
        },
        arrowIcon: {
            color: themes.palette.primary.main,
            fontSize: 20,
        },
    }));
    const classes = useStyles();
    return (
        <div
            className="px-3 d-flex justify-content-between align-items-center"
            onClick={onClick}
            style={{
                marginBottom: `17px`,
            }}
        >
            <div className={`${classes.title}`}>{title}</div>
            {shouldShowArrow && <ArrowForwardIosIcon className={classes.arrowIcon} />}
        </div>
    );
}
